import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';

import { AuthService } from 'src/app/core/service/auth.service';
import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PlatformLocation } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: [ './app.component.scss' ]
})
export class AppComponent {
	currentUrl: string;

	constructor(
		public _router: Router,
		location: PlatformLocation,
		private spinner: NgxSpinnerService,
		private translate: TranslateService
	) {
		translate.addLangs([ 'default-eng' ]);
		translate.setDefaultLang('default-eng');
		const browserLang = translate.getBrowserLang();
		translate.use(browserLang.match(/default-eng|mr/) ? browserLang : 'default-eng');

		this._router.events.subscribe((routerEvent: Event) => {
			if (routerEvent instanceof NavigationStart) {
				this.spinner.show();
				this.currentUrl = routerEvent.url.substring(routerEvent.url.lastIndexOf('/') + 1);
			}
			if (routerEvent instanceof NavigationEnd) {
				this.spinner.hide();
			}
			window.scrollTo(0, 0);
		});

		window.addEventListener('storage', (event) => {
			if (event.storageArea == localStorage) {
				let token = localStorage.getItem('accessToken');
				if (token == undefined) {
					// Perform logout
					//Navigate to login
					this._router.navigate([ '/authentication/signin' ]);
				}
			}
		});
	}
}
